export default {"src":"/_next/static/media/money_with_wings_color.3a10efaf.svg","height":32,"width":32};